import { OrderDetailItemsLayout } from './OrderDetailItemsLayout';
import { Icon } from '../../../../Product/components/Icon';

export type DetailItemProps = {
	id: string;
	size?: string;
	product: { id: string; name: string };
	price: string;
	quantity: string;
	tax_amount: string;
	modifiers: [
		{
			modifier: {
				name: string;
			};
		}
	];
};

export const OrderDetailItem: React.FC<DetailItemProps> = ({
	size,
	product,
	price,
	quantity,
	tax_amount,
	modifiers,
	...props
}) => {
	return (
		<OrderDetailItemsLayout
			icon={<Icon {...product} />}
			name={`${size ? size + ' ' : ''}${product.name}`}
			{...props}
			modifiers={modifiers}
			price={price.toString()}
		/>
	);
};
